export const TENANT_RESOURCE_KEYS = [
  "assets",
  "projects",
  "calendar",
  "runs",
  "skills",
  "inbox",
  "blogs",
  "brands",
];

export const EMPTY_TENANT_SINGLETONS = {
  brand: {},
  activeBrandId: null,
};

export function clearTenantResources(state = {}) {
  const cleared = TENANT_RESOURCE_KEYS.reduce(
    (next, key) => ({ ...next, [key]: [] }),
    { ...state },
  );
  return { ...cleared, ...EMPTY_TENANT_SINGLETONS };
}
